import React, { useEffect, useState } from "react";
import {
  Button,
  Input,
  Select,
  SelectItem,
  Checkbox,
  Alert,
  Spinner,
} from "@heroui/react";

const OperatorForm = ({ initialData, onCancel, getOperators }) => {  
const [operatorForm, setOperatorForm] = useState({
  operator_id: initialData?.operator_id || "",
  environment: initialData?.environment || "",
  callback_url: initialData?.callback_url || "", 
});


  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [showErrorAlert, setShowErrorAlert] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
const [showForm, setShowForm] = useState(false);
const [editingOperator, setEditingOperator] = useState(null);
  // Load initial data if editing
useEffect(() => {
  if (initialData) {
    setOperatorForm({
      operator_id: initialData[0].operator_id || "",
      environment: initialData[0].environment || "",
      callback_url: initialData[0].callback_url || "",
    });
  } else {
    // If no initialData (Add mode), clear form
    setOperatorForm({
      operator_id: "",
      environment: "",
      callback_url: "",
    });
  }
}, [initialData]);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setOperatorForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

const handleSubmit = async () => {
  const { operator_id, environment, callback_url } = operatorForm;

  if (!operator_id || !environment || !callback_url) {
    setErrorMessage("Please fill all required fields");
    setShowErrorAlert(true);
    return;
  }

  setIsSubmitting(true);
  setShowErrorAlert(false);

  try {
    const url = `${process.env.REACT_APP_API_HOST}/operator`;

    const res = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("jwt")}`,
      },
      body: JSON.stringify(operatorForm),
    });

    const data = await res.json();
    console.log(data, "data");

    if (res.status === 201) {
      setAlertMessage("Operator added successfully");
      setShowAlert(true);
      if (getOperators) await getOperators();

      setTimeout(() => {
        setShowAlert(false);
        if (onCancel) onCancel();
      }, 1500);
    } else if (res.status === 400) {
      // Show backend message if present, else fallback
      setErrorMessage(data.message || "Operator ID already exists.");
      setShowErrorAlert(true);
    } else {
      setErrorMessage("Failed to add operator");
      setShowErrorAlert(true);
    }
  } catch (error) {
    console.error("Operator Submit Error:", error);
    setErrorMessage("Something went wrong");
    setShowErrorAlert(true);
  } finally {
    setIsSubmitting(false);
  }
};




  const handleUpdateOperator = async () => {
    const { operator_id, environment, callback_url } = operatorForm;

    if (!operator_id || !environment || !callback_url) {
      setErrorMessage("Please fill all required fields");
      setShowErrorAlert(true);
      return;
    }

    setIsSubmitting(true);
    setShowErrorAlert(false);

    try {
      const url = `${process.env.REACT_APP_API_HOST}/operator/${initialData[0].id}`;

      const res = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("jwt")}`,
        },
        body: JSON.stringify({
          ...operatorForm,
        }),
      });

      const data = await res.json();

      if (res.ok) {
        setAlertMessage("Operator updated successfully");
        setShowAlert(true);
        getOperators();

        setTimeout(() => {
          setShowAlert(false);
          onCancel();
        }, 1500);
      } else {
        setErrorMessage(data?.message || "Failed to update operator");
        setShowErrorAlert(true);
      }
    } catch (error) {
      console.error("Update Operator Error:", error);
      setErrorMessage("Something went wrong while updating operator");
      setShowErrorAlert(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-32">
        <Spinner size="lg" variant="spinner" />
      </div>
    );
  }

  return (
    <div className="bg-white shadow rounded-lg p-6 mb-6">
      {showAlert && (
        <Alert
          color="success"
          className="mb-4"
          onClose={() => setShowAlert(false)}
        >
          {alertMessage}
        </Alert>
      )}
      {showErrorAlert && (
        <Alert
          color="danger"
          className="mb-4"
          onClose={() => setShowErrorAlert(false)}
        >
          {errorMessage}
        </Alert>
      )}

      <h3 className="text-lg font-medium text-gray-900 mb-4">
        {initialData ? "Edit Operator" : "Add New Operator"}
      </h3>

      <form className="space-y-4" onSubmit={(e) => e.preventDefault()}>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Operator Id <span className="text-red-500">*</span>
            </label>
            <Input
              type="text"
              name="operator_id"
              value={operatorForm.operator_id}
              onChange={handleChange}
              placeholder="Enter Operator Id"
              className="border border-gray-300 rounded-xl"
              autoComplete="off"
              required
              // disabled={!!initialData} // disable in edit mode
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Environment <span className="text-red-500">*</span>
            </label>
            <Select
              selectedKeys={[operatorForm.environment]}
              onSelectionChange={(keys) => {
                const selected = [...keys][0];
                setOperatorForm((prev) => ({
                  ...prev,
                  environment: selected,
                }));
              }}
              placeholder="Select Environment"
            >
              <SelectItem key="Staging" value="staging">
                Staging
              </SelectItem>
              <SelectItem key="Production" value="production">
                Production
              </SelectItem>
            </Select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Callback Url <span className="text-red-500">*</span>
            </label>
            <Input
              type="url"
              name="callback_url"
              value={operatorForm.callback_url}
              onChange={handleChange}
              placeholder="https://example.com/"
              className="border border-gray-300 rounded-xl"
              autoComplete="off"
              required
            />
          </div>
        </div>

        {/* <div className="mt-4">
          <Checkbox
            isSelected={operatorForm.status}
            onChange={() =>
              setOperatorForm((prev) => ({
                ...prev,
                status: !prev.status,
              }))
            }
            color="success"
          >
            Status: {operatorForm.status ? "Active" : "Inactive"}
          </Checkbox>
        </div> */}

        <div className="flex justify-end space-x-3 mt-6">
          <Button color="danger" variant="light" onClick={onCancel}>
            Cancel
          </Button>
          {initialData ? (
            <Button
              type="button"
              onClick={handleUpdateOperator}
              className="bg-blue-600 text-white"
              isLoading={isSubmitting}
              disabled={isSubmitting}
            >
              Update Operator
            </Button>
          ) : (
            <Button
              type="button"
              onClick={handleSubmit}
              className="bg-blue-600 text-white"
              isLoading={isSubmitting}
              disabled={isSubmitting}
            >
              Save Operator
            </Button>
          )}
        </div>
      </form>
    </div>
  );
};

export default OperatorForm;
